import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import BookingDateRangeFilter from '../../components/Booking/BookingDateRangeFilter/BookingDateRangeFilter';
import KeywordFilter from '../../components/Filters/KeywordFilter/KeywordFilter';
import PriceFilter from '../../components/Filters/PriceFilter/PriceFilter';
import SelectMultipleFilter from '../../components/Filters/SelectMultipleFilter/SelectMultipleFilter';
import SelectSingleFilter from '../../components/Filters/SelectSingleFilter/SelectSingleFilter';
import TimeSelectFilter from '../../components/Filters/TimeSelectFilter/TimeSelectFilter';

/**
 * FilterComponent is used to map configured filter types
 * to actual filter components
 */
const FilterComponent = ({
  idPrefix,
  filterConfig,
  initialValues,
  getHandleChangedValueFn,
  ...rest
}) => {
  const { id, type, queryParamNames, label, config } = filterConfig;
  const { liveEdit, showAsPopup } = rest;
  const intl = useIntl();

  const prefix = idPrefix || 'SearchPage';
  const componentId = `${prefix}.${id.toLowerCase()}`;
  const name = id.replace(/\s+/g, '-').toLowerCase();
  const useHistoryPush = liveEdit || showAsPopup;

  switch (type) {
    case 'SelectSingleFilter': {
      return (
        <SelectSingleFilter
          filterConfig={filterConfig}
          id={componentId}
          initialValues={initialValues(queryParamNames)}
          label={intl.formatMessage({ id: label })}
          onSelect={getHandleChangedValueFn(useHistoryPush)}
          queryParamNames={queryParamNames}
          {...config}
          {...rest}
        />
      );
    }
    case 'SelectMultipleFilter': {
      return (
        <SelectMultipleFilter
          filterConfig={filterConfig}
          id={componentId}
          initialValues={initialValues(queryParamNames)}
          label={intl.formatMessage({ id: label })}
          name={name}
          onSubmit={getHandleChangedValueFn(useHistoryPush)}
          queryParamNames={queryParamNames}
          {...config}
          {...rest}
        />
      );
    }
    case 'BookingDateRangeFilter': {
      return (
        <BookingDateRangeFilter
          filterConfig={filterConfig}
          id={componentId}
          initialValues={initialValues(queryParamNames)}
          label={intl.formatMessage({ id: label })}
          onSubmit={getHandleChangedValueFn(useHistoryPush)}
          queryParamNames={queryParamNames}
          {...config}
          {...rest}
        />
      );
    }
    case 'PriceFilter': {
      return (
        <PriceFilter
          filterConfig={filterConfig}
          id={componentId}
          initialValues={initialValues(queryParamNames)}
          label={intl.formatMessage({ id: label })}
          onSubmit={getHandleChangedValueFn(useHistoryPush)}
          queryParamNames={queryParamNames}
          {...config}
          {...rest}
        />
      );
    }
    case 'KeywordFilter':
      return (
        <KeywordFilter
          filterConfig={filterConfig}
          id={componentId}
          initialValues={initialValues(queryParamNames)}
          label={intl.formatMessage({ id: label })}
          name={name}
          onSubmit={getHandleChangedValueFn(useHistoryPush)}
          queryParamNames={queryParamNames}
          {...config}
          {...rest}
        />
      );
    case 'TimeSelectFilter':
      return (
        <TimeSelectFilter
          filterConfig={filterConfig}
          id={componentId}
          initialValues={initialValues(queryParamNames)}
          label={intl.formatMessage({ id: label })}
          onSelect={getHandleChangedValueFn(useHistoryPush)}
          queryParamNames={queryParamNames}
          {...config}
          {...rest}
        />
      );
    default:
      return null;
  }
};

export default memo(FilterComponent);
